<template>
  <div
    v-if="
      type === 'concert' ||
        type === 'festival' ||
        type === 'artist' ||
        type === 'venue'
    "
    class="followers-fake"
  >
    <section class="user-card blurred">
      <user-card
        v-for="follower in followers"
        :key="follower.id"
        :user="follower"
        :is-fake="true"
      />
      <div class="gradient-container">
        <div class="followers-gradient lg:block hidden"></div>
      </div>
    </section>
    <section class="lg:hidden block blurred">
      <carousel
        class="carousel fixed-carousel-arrows"
        :wrap-around="false"
        :transition="500"
        :breakpoints="BREAKPOINTS.eventProfileRelated"
      >
        <slide
          v-for="follower in followers.slice(0, 3)"
          :key="follower.id"
          :aria-hidden="false"
        >
          <profile-card :profile="follower" type="profile-sm-card" />
        </slide>
        <template #addons>
          <navigation />
        </template>
      </carousel>
    </section>
    <div class="wrapper">
      <p>
        {{ $t("wegow.banner.fakeUsers." + type) }}
      </p>
      <wegow-button
        button-id="next-step-button"
        class="mt-4"
        background="opacity"
        color="topaz"
        type="button"
        :text="$t('wegow.login.signup')"
        @click="openModal(SIGN_IN)"
      />
    </div>
  </div>

  <div v-else class="section followers-fake">
    <carousel
      class="carousel fixed-carousel-arrows blurred"
      :wrap-around="false"
      :transition="500"
      :breakpoints="breakpoints.basicCards"
    >
      <slide
        v-for="profile in followers"
        :key="profile.id"
        class="mx-1"
        :aria-hidden="false"
      >
        <profile-card v-if="profile" :profile="profile" />
      </slide>
      <template #addons>
        <navigation />
      </template>
    </carousel>
    <div class="wrapper">
      <p>
        {{ $t("wegow.banner.fakeUsers." + type) }}
      </p>
      <wegow-button
        button-id="next-step-button"
        class="mt-4"
        background="opacity"
        color="topaz"
        type="button"
        :text="$t('wegow.login.signup')"
        @click="openModal(SIGN_IN)"
      />
    </div>
  </div>
</template>
<script setup>
import UserCard from "@/components/general/ui/UserCard.vue";
import ProfileCard from "@/components/wegow/ui/cards/ProfileCard.vue";
import WegowButton from "@/components/general/forms/WegowButton";
import { BREAKPOINTS } from "@/constants.js";

import { ref } from "vue";
import { Carousel, Navigation, Slide } from "vue3-carousel";
import { useModalHandler } from "@/plugins/useModalHandler";

const { SIGN_IN, openModal } = useModalHandler();

defineProps({
  type: {
    type: String,
    default: "concert"
  }
});

let followers = ref([
  {
    id: 865621,
    first_name: "Usuario",
    slug: "fake-friend",
    friendship: {
      status: "none"
    },
    image_url: require("@/assets/images/fake-user-0.webp")
  },
  {
    id: 865622,
    first_name: "Usuario",
    slug: "fake-friend",
    friendship: {
      status: "none"
    },
    image_url: require("@/assets/images/fake-user-1.webp")
  },
  {
    id: 865623,
    first_name: "Usuario",
    slug: "fake-friend",
    friendship: {
      status: "none"
    },
    image_url: require("@/assets/images/fake-user-2.webp")
  },
  {
    id: 865624,
    first_name: "Usuario",
    slug: "fake-friend",
    friendship: {
      status: "none"
    },
    image_url: require("@/assets/images/fake-user-3.webp")
  },
  {
    id: 865625,
    first_name: "Usuario",
    slug: "fake-friend",
    friendship: {
      status: "none"
    },
    image_url: require("@/assets/images/fake-user-4.webp")
  },
  {
    id: 865626,
    first_name: "Usuario",
    slug: "fake-friend",
    friendship: {
      status: "none"
    },
    image_url: require("@/assets/images/fake-user-5.webp")
  },
  {
    id: 865627,
    first_name: "Usuario",
    slug: "fake-friend",
    friendship: {
      status: "none"
    },
    image_url: require("@/assets/images/fake-user-6.webp")
  },
  {
    id: 865628,
    first_name: "Usuario",
    slug: "fake-friend",
    friendship: {
      status: "none"
    },
    image_url: require("@/assets/images/fake-user-7.webp")
  },
  {
    id: 865629,
    first_name: "Usuario",
    slug: "fake-friend",
    friendship: {
      status: "none"
    },
    image_url: require("@/assets/images/fake-user-8.webp")
  }
]);
const breakpoints = {
  basicCards: {
    700: {
      itemsToShow: 1.5,
      snapAlign: "start"
    },
    900: {
      itemsToShow: 2.1,
      snapAlign: "start"
    },
    1200: {
      itemsToShow: 2.45,
      snapAlign: "start"
    },
    1280: {
      itemsToShow: 1.6,
      snapAlign: "start"
    },
    1600: {
      itemsToShow: 2.6,
      snapAlign: "start"
    }
  },
  eventCards: {
    700: {
      itemsToShow: 2,
      snapAlign: "start"
    },
    900: {
      itemsToShow: 2.8,
      snapAlign: "start"
    },
    1200: {
      itemsToShow: 3.4,
      snapAlign: "start"
    },
    1280: {
      itemsToShow: 2.1,
      snapAlign: "start"
    },
    1600: {
      itemsToShow: 3.5,
      snapAlign: "start"
    }
  },
  images: {
    700: {
      itemsToShow: 1.2,
      snapAlign: "start"
    },
    900: {
      itemsToShow: 1.8,
      snapAlign: "start"
    },
    1200: {
      itemsToShow: 2.3,
      snapAlign: "start"
    },
    1280: {
      itemsToShow: 1.4,
      snapAlign: "start"
    },
    1600: {
      itemsToShow: 2.2,
      snapAlign: "start"
    }
  }
};
</script>

<style lang="scss" scoped>
.followers-fake {
  position: relative;

  .blurred {
    opacity: 0.25;
    filter: blur(2px);
  }

  .wrapper {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    p {
      text-align: center;
      font-size: 16px;
    }
  }
}
@import "@/components/general/ui/profiles/profiles.scss";
.user-card {
  display: none;
  @media screen and (min-width: $screen-lg) {
    display: grid;
    grid-template-columns: repeat(3, 100px);
    gap: 0.75rem; // 12px
    overflow: hidden;
    position: relative;
    justify-content: center;
  }
}
</style>
